import { render, staticRenderFns } from "./XR2.vue?vue&type=template&id=31ccf366&scoped=true"
import script from "./XR2.vue?vue&type=script&lang=js"
export * from "./XR2.vue?vue&type=script&lang=js"
import style0 from "./XR2.vue?vue&type=style&index=0&id=31ccf366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccf366",
  null
  
)

export default component.exports